export default function() {
  let self = this;
  self.threads = ko.observableArray([]);
  self.fullLoading = ko.observable(true);
  if ($('#course_id').val() != 'undefined'){
   self.course_id = JSON.parse($('#course_id').val());
  }

  let forum_ele = $('#forum_id').val();
  if(!_.isEmpty(forum_ele)){
    self.forum_id = JSON.parse(forum_ele);
  }

  self.loadThreads = function() {
    self.fullLoading(true);
    let mProgress = new Mprogress({
      template: 4,
      start: true,
      parent: '#js-loader'
    });

    let url = Kadenze.Routes.course_threads_path(self.course_id);
    if(_.isNumber(self.forum_id)){
      url = Kadenze.Util.insertURLParam(url, 'forum', self.forum_id);
    }

    let request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url
    });

    request.done(function(data, status, xhr) {
      self.threads(ko.mapping.fromJS(data.forum_threads)());
    });

    request.fail(function(xhr, status, error) {
      // do nothing for now
    });

    request.always(function() {
      self.fullLoading(false);
      mProgress.end();
    });
  };

  self.userInfoTooltipParams = function (user) {
    return {
      template: 'templates/tooltip-userinfo',
      templateParams: {
        full_name: user.full_name(),
        username: user.slug(),
        email: null,
        avatar: user.avatar(),
        profile_path: user.profile_path(),
        message_path: user.message_path()
      },
      position: 'top',
      showDelay: .7
    };
  };

  // This is duplicated for now
  self.voteUp = function(thread) {
    let id = thread.id();
    let modifier = thread.voted() ? -1 : 1;
    let type = thread.voted() ? 'neutral' : 'up';
    thread.vote_count(thread.vote_count() + modifier);
    thread.voted(!thread.voted());
    $.getJSON('/threads/' + thread.id() + '/vote/' + type, {});
  };

  self.firstLetter = function(word) {
    return word().substr(0, 1);
  };

  const __construct = function(that) {
    console.log('constructor called for SimpleForumThreadPanelViewModel');
    if ($('#course_id').val() != 'undefined'){
      self.loadThreads();
    }
  }(this);
}
